module.exports = __webpack_public_path__ + "static/media/9DESA23.8c33c61d.jpg";